module.exports = __webpack_public_path__ + "img/INTERIOR-FRONX-BOOSTERGREEN-1.eae9aa48.jpg";